import { render, staticRenderFns } from "./MultiCreateCoupon.vue?vue&type=template&id=298b80cb&scoped=true"
import script from "./MultiCreateCoupon.vue?vue&type=script&lang=js"
export * from "./MultiCreateCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b80cb",
  null
  
)

export default component.exports